import {API} from "./API";
import {Service} from "../models/Service";

export class ServicesAPI extends API<Service> {

	constructor () {
		super("services");
    }
}
